var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"art-guide-events-group-reorder-action",attrs:{"type":"button","title":"Reorder"}},_vm.$listeners),[_c('ArtGuideEventDragIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }